import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d14ab5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "atcs-impersonate container" }
const _hoisted_2 = { class: "row impersonate-box" }
const _hoisted_3 = { class: "ls-form" }
const _hoisted_4 = {
  key: 0,
  class: "set-date mt-2 mb-3"
}
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Adjusted Date "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'open sans'"} }, "(Optional)")
], -1))
const _hoisted_7 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_9 = {
  class: "mt-2 mb-3",
  style: {"display":"flex","justify-content":"space-between","flex-flow":"row nowrap"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "autocomplete" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Search for LawID", -1))
const _hoisted_15 = { class: "icon-hm" }
const _hoisted_16 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_17 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_18 = {
  id: "autocomplete-results",
  class: "autocomplete-results ml-2"
}
const _hoisted_19 = ["innerHTML", "onClick"]
const _hoisted_20 = {
  key: 1,
  class: "autocomplete-result"
}
const _hoisted_21 = { class: "input-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "LawID", -1))
const _hoisted_23 = { class: "text-field" }
const _hoisted_24 = { class: "input-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name", -1))
const _hoisted_26 = { class: "text-field" }
const _hoisted_27 = { class: "input-box" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name", -1))
const _hoisted_29 = { class: "text-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Practice name(s)", -1))
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  class: "mt-3",
  style: {"display":"flex","justify-content":"space-between","flex-flow":"row nowrap"}
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_DatePicker = _resolveComponent("DatePicker")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.impersonatingUser)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("h2", null, "Welcome " + _toDisplayString(_ctx.userAccount.user.firstName) + ",", 1),
          (this.env.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_DatePicker, {
                      class: "v3-date-picker",
                      style: {"padding":"1em"},
                      modelValue: _ctx.adjustedDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.adjustedDate) = $event)),
                      inputFormat: "dd-MM-yyyy",
                      lowerLimit: _ctx.minDate,
                      upperLimit: _ctx.maxDate
                    }, null, 8, ["modelValue", "lowerLimit", "upperLimit"]),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-outline mr-1",
                    style: {"width":"100%"},
                    onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.setSystemDate(true)), ["prevent"])),
                    disabled: _ctx.isToday
                  }, "Reset date", 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-primary ml-1",
                    style: {"width":"100%"},
                    onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.setSystemDate(false)), ["prevent"])),
                    disabled: _ctx.isToday
                  }, "Apply date", 8, _hoisted_11)
                ]),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              onKeydown: [
                _cache[3] || (_cache[3] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                _cache[4] || (_cache[4] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                _cache[5] || (_cache[5] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
              ],
              class: "searchField",
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.search) = $event)),
              placeholder: "Enter LawID"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "hidden",
              id: "practitioner",
              name: "practitioner",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.currentSelectedLawId) = $event))
            }, null, 512), [
              [_vModelText, _ctx.currentSelectedLawId]
            ]),
            _createElementVNode("span", _hoisted_15, [
              (_ctx.isSearching)
                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                : (_openBlock(), _createElementBlock("i", _hoisted_17))
            ]),
            _withDirectives(_createElementVNode("ul", _hoisted_18, [
              (_ctx.practitionerList?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.practitionerList, (practitioner, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                      innerHTML: _ctx.highlightWord(_ctx.formatPractitionerText(practitioner)),
                      onClick: _withModifiers($event => (_ctx.selectPractitioner(practitioner)), ["prevent"])
                    }, null, 10, _hoisted_19))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_20, "No Result"))
            ], 512), [
              [_vShow, _ctx.isOpen]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.currentSelectedLawId?.lawId ?? ''), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.currentSelectedLawId?.firstName ?? ''), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.currentSelectedLawId?.lastName ?? ''), 1)
          ]),
          _hoisted_30,
          _createElementVNode("div", {
            class: "text-field",
            style: {"min-height":"150px","overflow-y":"scroll"},
            innerHTML: _ctx.formatPracticesText(_ctx.currentSelectedLawId)
          }, null, 8, _hoisted_31),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              class: "btn btn-outline mr-1",
              disabled: _ctx.impersonatingUser,
              style: {"width":"100%"}
            }, "My Account", 8, _hoisted_33),
            _createElementVNode("button", {
              class: "btn btn-primary ml-1",
              disabled: !_ctx.currentSelectedLawId || _ctx.impersonatingUser,
              style: {"width":"100%"},
              onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.impersonateUser(_ctx.currentSelectedLawId?.lawId)), ["prevent"]))
            }, "Continue", 8, _hoisted_34)
          ])
        ])
      ])
    ])
  ]))
}